import { render } from "./Inventory-product.vue?vue&type=template&id=40733e3c"
import script from "./Inventory-product.vue?vue&type=script&lang=js"
export * from "./Inventory-product.vue?vue&type=script&lang=js"
script.render = render

export default script